// Custom JavaScript for catalog page modifications
(function () {
  "use strict";

  // Wait for the Collection class to be initialized
  function initCustomGridBehavior() {
    if (typeof MinimogTheme === "undefined" || !MinimogTheme.Collection) {
      setTimeout(initCustomGridBehavior, 100);
      return;
    }

    // Store original method
    const originalUpdateViewByScreen =
      MinimogTheme.Collection.updateViewByScreen;

    // Override the updateViewByScreen method
    MinimogTheme.Collection.updateViewByScreen = function () {
      // Custom responsive behavior for 4-column grid
      if (this.initialCol === 4) {
        const device = this.getDeviceByScreenSize();
        let targetCol = 4; // Default to 4 columns on desktop

        if (device === "mobile") {
          targetCol = 2; // 2 columns on mobile
        } else if (device === "tablet") {
          targetCol = 3; // 3 columns on tablet
        }

        if (targetCol !== this.activeCol) {
          this.toggleView(targetCol);
        }
        return;
      }

      // Use original behavior for other layouts
      if (originalUpdateViewByScreen) {
        originalUpdateViewByScreen.call(this);
      }
    };

    // Also override the MAX_COL_BY_SCREEN_SIZE for our custom behavior
    if (MinimogTheme.Collection.MAX_COL_BY_SCREEN_SIZE) {
      MinimogTheme.Collection.MAX_COL_BY_SCREEN_SIZE = {
        mobile: 2,
        tablet: 3,
        desktop: 4, // Allow 4 columns on desktop
      };
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCustomGridBehavior);
  } else {
    initCustomGridBehavior();
  }

  // Ensure proper grid classes are maintained
  window.addEventListener("load", function () {
    const productContainer = document.querySelector("[data-product-container]");
    if (productContainer) {
      // Force responsive grid behavior
      function updateGridResponsively() {
        const width = window.innerWidth;

        if (width < 768) {
          // Mobile: 2 columns
          productContainer.className = productContainer.className.replace(
            /m-cols-\d+/,
            "m-cols-2"
          );
        } else if (width < 1024) {
          // Tablet: 3 columns
          productContainer.className = productContainer.className.replace(
            /m-cols-\d+/,
            "m-cols-3"
          );
        } else {
          // Desktop: 4 columns
          productContainer.className = productContainer.className.replace(
            /m-cols-\d+/,
            "m-cols-4"
          );
        }
      }

      // Apply immediately
      updateGridResponsively();

      // Apply on resize
      let resizeTimeout;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateGridResponsively, 100);
      });
    }
  });
})();
